import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as fromComponents from './components';
import { SharedModule } from '@app/shared/shared.module';
import { DatePipe } from '@angular/common'

import { BulkUploadOrdersRoutingModule } from './bulk-upload-orders-routing.module';
import { BulkUploadOrdersComponent } from './bulk-upload-orders.component';
import { OrderValidationComponent } from './components/order-validation/order-validation.component';
import { OrderUploadPreviewComponent } from './components/order-upload-preview/order-upload-preview.component';


@NgModule({
  imports: [SharedModule,
    CommonModule,
    BulkUploadOrdersRoutingModule
  ],
  declarations: [
    BulkUploadOrdersComponent,...fromComponents.components, OrderValidationComponent, OrderUploadPreviewComponent
  ],
  exports: [BulkUploadOrdersComponent, ...fromComponents.components],
  providers: [DatePipe]
})
export class BulkUploadOrdersModule { }
